export const getJokerColors = (isJoker: boolean) => {
  return {
    backgroundColor: isJoker ? 'var(--pink-100)' : 'var(--yellow)',
    color: isJoker ? 'var(--color-white)' : 'var(--gray-600)',
  };
};
